import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';

export class ReferenceSpreadsheetConfig<
  I extends object,
  COLUMN extends object,
  TD extends object,
  CD extends object = object,
> extends SpreadsheetConfig<I, COLUMN, TD, CD> {
  getCellKey(colLegend: string, rowIndex: number): string {
    return colLegend + rowIndex;
  }
}
